import React from 'react';
import PropTypes from 'prop-types';

const Wallet = ({ fill = '#434343' }) => (
  <svg
    width="20px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Wallet"
        transform="translate(-6.000000, -6.000000)"
        fill={fill}
        fillRule="nonzero"
      >
        <g transform="translate(6.000000, 6.000000)" id="wallet">
          <g>
            <path
              d="M23.7991164,11.1760478 L22.6480478,11.1760478 L22.6480478,5.88107463 C22.6480478,4.61165373 21.6153313,3.57893731 20.3459104,3.57893731 L18.7869134,3.57893731 L17.1915224,0.710471642 C16.9483701,0.272095522 16.4856358,0 15.9837851,0 C15.7498746,0 15.5178269,0.0603223881 15.3129313,0.17401791 L9.19013731,3.57886567 L2.35092537,3.57886567 C1.08150448,3.57886567 0.0487880597,4.61158209 0.0487880597,5.88100299 L0.0487880597,21.6889791 C0.0487880597,22.9584 1.08150448,23.9911164 2.35092537,23.9911164 L20.3459104,23.9911164 C21.6153313,23.9911164 22.6480478,22.9584 22.6480478,21.6889791 L22.6480478,17.0464478 L23.7991164,17.0464478 L23.7991164,11.1760478 Z M20.3459104,4.49974925 C21.0549493,4.49974925 21.6341731,5.03842388 21.7119761,5.72768955 L19.9816836,5.72768955 L19.2992955,4.49974925 L20.3459104,4.49974925 Z M21.7271642,21.6889791 C21.7271642,22.4505313 21.107391,23.0703045 20.3458388,23.0703045 L2.35092537,23.0703045 C1.58937313,23.0703045 0.9696,22.4505313 0.9696,21.6889791 L0.9696,5.88107463 C0.9696,5.11952239 1.58937313,4.49974925 2.35092537,4.49974925 L7.53442388,4.49974925 L5.32620896,5.72776119 L2.63871045,5.72776119 C2.38409552,5.72776119 2.17826866,5.93401791 2.17826866,6.18820299 C2.17826866,6.44238806 2.38409552,6.64864478 2.63871045,6.64864478 L3.67006567,6.64864478 L20.4937075,6.64864478 L21.7271642,6.64864478 L21.7271642,11.1764776 L18.3600716,11.1764776 C16.7964179,11.1764776 15.5238448,12.4491224 15.5238448,14.0127045 L15.5238448,14.2107224 C15.5238448,15.7743761 16.7964896,17.0469493 18.3600716,17.0469493 L21.7271642,17.0469493 L21.7271642,21.6889791 Z M22.8782328,16.1256358 L22.6480478,16.1256358 L18.3600716,16.1256358 C17.3038567,16.1256358 16.4446567,15.2665075 16.4446567,14.2102209 L16.4446567,14.012203 C16.4446567,12.9559881 17.3037851,12.0967881 18.3600716,12.0967881 L22.6480478,12.0967881 L22.8782328,12.0967881 L22.8782328,16.1256358 Z M19.7703403,14.1490388 C19.7703403,14.7107821 19.3154149,15.1656358 18.7537433,15.1656358 C18.192,15.1656358 17.7371463,14.7107104 17.7371463,14.1490388 C17.7371463,13.5873672 18.1920716,13.1324418 18.7537433,13.1324418 C19.3154866,13.1323701 19.7703403,13.5877254 19.7703403,14.1490388 Z"
              id="Shape"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

Wallet.propTypes = {
  fill: PropTypes.string,
};

export default Wallet;
